<template lang="pug">
  .component-base-list
    p.text-center Total results: {{ data.items_count || data.items_count === 0 ? data.items_count : '...loading...' }}
    slot(name="before", v-if="data.items_count > 0")
    .list-items
      h2.no-result-message.text-center(v-if="data.items_count === 0") Nothing to show here yet :(
      loading-spinner(v-if='!data.items')
      .select-all(v-if="selectableList")
        input(type="checkbox", @click="selectAllCheckboxes", v-model="selectAll")
        label Select all
      .list-item(v-for="(item, i) in data.items", :key="item.id", :class="{'list-odd': i%2, 'flex-list':selectableList}")
        input(v-if="selectableList", type="checkbox", v-model="selected" :value="item.id", @input="checkboxChanged(i, $event.target)")
        component(:is="component", :item="item", :type="componentType", :id="item.id", @itemUpdated="loadData(1)" )
    slot(name="after")
    .row(v-if="showPerPageSelect")
      .column.shrink
        select(v-model="resultsPerPageSelect", @change="setResultsPerPage")
          option 5
          option 10
          option 25
          option 45
          option 60
      .column
        pagination(:results="data.items_count", :perPage="data.per_page_count", :currentPage="currentPage", @pageUpdated="loadData")
</template>

<script type="text/babel">

  import Pagination from 'components/structure/foundation/Pagination'
  import LoadingSpinner from 'components/structure/LoadingSpinner'
  import {EventBus} from "src/eventBus";

  export default {
    name: 'BaseList',
    components: {
      LoadingSpinner,
      Pagination,
      EventBus,
    },
    data: function () {
      return {
        selected: [],
        data: [],
        currentPage: 1,
        debouncedLoader: null,
        searchRange: null,
        lastSearchRange: null,
        resultsPerPageSelect: null,
        selectAll: false,
      }
    },
    methods: {
      setResultsPerPage() {
        this.loadData(this.currentPage)
      },
      loadData(page) {
        this.data = []
        this.currentPage = page
        this.$emit('pageChanged', {page:page, comp:this.$props.component.name})
        const loader = this.dataLoader((data) => {
          this.selectAll = false
          this.data = data
        }, page, this.resultsPerPageSelect, this.search)
        this.searchRange = Object.assign({}, this.search)
        if (typeof this.searchRangeDataLoader !== 'undefined') {

          if (this.search === null || this.search.from === null || this.search.to === null) {
            this.searchRange.start = this.$date().startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
            this.searchRange.end = this.$date().endOf('month').subtract(1, 'month').format('YYYY-MM-DD')
          } else {
            this.searchRange.start = this.search.from
            this.searchRange.end = this.search.to
          }

          if (typeof this.searchRange.start === 'undefined') {
            this.searchRange.start = this.$date().startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
          }

          if (typeof this.searchRange.end === 'undefined') {
            this.searchRange.end = this.$date().endOf('month').subtract(1, 'month').format('YYYY-MM-DD')
          }

          // TODO: need refactor for check all object keys and values
          /*if (!this.lastSearchRange ||
           searchRange.start !== this.lastSearchRange.start ||
           searchRange.end !== this.lastSearchRange.end) {
            this.searchRangeDataLoader(searchRange)
            this.lastSearchRange = Object.assign({}, searchRange)
          }*/
          this.searchRangeDataLoader(this.searchRange)
          this.lastSearchRange = Object.assign({}, this.searchRange)
        }
        return loader
      },
      checkboxChanged(index, evt) {
        if (evt.checked) {
          this.selected.push(evt.value)
        } else {
          const position = this.selected.indexOf(evt.value)
          this.selected.splice(position, 1)
        }

        this.$emit('input', this.selected)
      },
      selectAllCheckboxes() {
        if (!this.selectAll === true) {
          this.selected = this.data.items.map((item) => {
            return item.id
          })
        } else {
          this.selected = []
        }

        this.$emit('input', this.selected)
      }
    },
    destroyed() {
      EventBus.$off('reload-list')
    },
    created() {
      EventBus.$on('reload-list', () => {
        this.loadData(1)
      })

      if (this.selectableList) {
        this.selected = this.value
      }

      this.resultsPerPageSelect = this.resultsPerPage
      this.debouncedLoader = this.$debounce(() => {
        this.loadData(1)
      }, 350)

      this.debouncedLoader()
    },
    watch: {
      search: {
        handler: function (newVal, oldVal) {
          this.debouncedLoader()
        },
        deep: true
      }
    },

    props: {

      // The item list component
      component: {
        type: Object,
        required: true
      },
      // The component flavour
      componentType: {
        type: String,
        required: false,
        default: 'listing'
      },
      // Function used to load the data
      dataLoader: {
        type: Function,
        required: true
      },
      // Search object that will be passed to dataLoader
      search: {
        type: Object,
        required: false,
        default: null
      },
      // How many results per page we want
      resultsPerPage: {
        type: Number,
        required: false,
        default: 25 // 25 is the correct number
      },
      // Additional data loader, extracts the range from the search array
      searchRangeDataLoader: {
        type: Function,
        required: false
      },
      showPerPageSelect: {
        type: Boolean,
        default: true
      },
      selectableList: {
        type: Boolean,
        default: false
      },
      value: {}
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  #application
    height: 100%

    .component-base-list
      .component-header-columns, .list-items
        background-color: white

      .list-items
        margin-bottom: 1em

        .list-item
          &.flex-list
            display: flex
            flex-direction: row
            align-items: flex-end
            div
              width: 100%
              text-align: left

            *
              margin-right: 0.5em

        .component-header-columns
          .columns
            white-space: nowrap

        .list-item > .component > .card, .list-item .card
          margin: 0

        .list-item:not(.list-odd)
          .component-card > .row, .inner-content
            background-color: #f4f8f8
            padding: 1em 1.5em

            .row
              background-color: transparent

        .list-item.list-odd
          .component-card > .row, .inner-content
            background-color: #FFFFFF
            padding: 1em 1.5em

            .row
              background-color: transparent

        .component-invoice
          a.fa
            margin-right: .5em

          p
            margin: auto
</style>



// WEBPACK FOOTER //
// BaseList.vue?1d2c8b60